import { RECENT_STORES_FROM_SEARCHBAR_VIEW } from './types';

export const triggerRecentStoresFromSearchViewed = payload => ({
  type: RECENT_STORES_FROM_SEARCHBAR_VIEW,
  payload,
});
